import { render } from "./RenderQuestion.vue?vue&type=template&id=cb1dbd74&scoped=true"
import script from "./RenderQuestion.vue?vue&type=script&lang=js"
export * from "./RenderQuestion.vue?vue&type=script&lang=js"

import "./RenderQuestion.vue?vue&type=style&index=0&id=cb1dbd74&scoped=true&lang=css"

import exportComponent from "E:\\Dev\\Univ\\vueQuizzly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb1dbd74"]])

export default __exports__